import { getEnumValues } from './get-enum-values';
export enum Tardiness{
	OnTime = "on-time",
	Late = "late",
	Absent = "absent",
}
export const TardinessValues = getEnumValues<Tardiness>(Tardiness)
